import ValidationInterface from '@/plans/common/validation-interface';
import { basePlanCategories } from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    return [this.current("ZVODMO").require(basePlanCategories, { licenseMatch: false })];

  }

  async conflicts() {
    return this.current(['ZVODMO']).conflict(['ZVODMO']);
  }
}
